import ScreenOverlayImage from './ScreenOverlayImage';
import Hud from '../hud/Hud';
import { GetDefaultButtonCostume } from '../hud/HudConstants';
import { GetLocationSelfieUrl } from '../../constants/AppUrls';
import ContentPanel from '../../display/ui/ContentPanel';
import ScreenContainer from '../../display/ui/ScreenContainer';
import LoadDisplay from '../../display/ui/LoadDisplay';

export default class ScreenOverlaySelfie extends ScreenContainer {
  constructor(game, { locationid }) {
    super(game, { background: 'background_alt_overlay', modal: true });

    // create the content panel to display image
    this.contentPanel = new ContentPanel(this.game);
    this.contentPanel.x = this.game.defaultWidth * 0.5 - this.contentPanel.width * 0.5;
    this.contentPanel.y = this.game.defaultHeight * 0.5 - this.contentPanel.height * 0.5;
    this.addChild(this.contentPanel);

    // listen for centent close : should the close button be in here?
    this.contentPanel.onClosePanel.add(this.closePanel, this);

    // dispatch when user closes screen, will auto hide itself
    this.onScreenClosed = new Phaser.Signal();
    this.locationid = locationid;

    this.imageurl = GetLocationSelfieUrl(locationid);
    this.loadImage(this.imageurl);
  }

  loadImage(imageurl) {
    this.imageurl = imageurl;

    // create a loader, we'll probably need this
    this.loadDisplay = new LoadDisplay(this.game, false);
    this.loadDisplay.scale.set(
      Math.min(1, (this.contentPanel.width / this.loadDisplay.width) * 0.5)
    );
    this.loadDisplay.x = this.contentPanel.width * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.contentPanel.height * 0.5 - this.loadDisplay.height * 0.5;
    this.contentPanel.add(this.loadDisplay);

    // reset loader and load image
    this.game.load.baseURL = '';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.image(imageurl, imageurl, true);
    this.game.load.onFileComplete.add(this.handleImageLoaded, this);
    this.game.load.start();
  }

  handleImageLoaded() {
    this.loadDisplay.visible = false;
    // kill listener
    this.game.load.onFileComplete.remove(this.handleImageLoaded, this);
    // display the loaded image
    this.displayImage(this.imageurl);
  }
  // panel is resized after image is loaded, so we need to wait before adding like button
  displayImage() {
    if (this.image) {
      this.image.destroy(true);
    }
    // create image sprite
    this.image = this.game.make.image(0, 0, this.imageurl);
    // figure out best scale for displaying the image
    const targetScale = Math.min(1, Math.min(911 / this.image.width, 550 / this.image.height));

    const targetHeight = this.image.height * targetScale;
    const targetWidth = this.image.width * targetScale;
    this.contentPanel.setSize(targetWidth, targetHeight);
    this.contentPanel.x = this.game.defaultWidth * 0.5 - this.contentPanel.width * 0.5;
    this.contentPanel.y = this.game.defaultHeight * 0.5 - this.contentPanel.height * 0.5;
    // scale and add the image
    this.image.scale.set(targetScale);
    this.contentPanel.addContent(this.image, true);

    this.liked = this.game.gameController.player.getSelfieLiked(this.locationid);

    // do we show button or icon?
    if (!this.liked) {
      this.addButton();
    } else {
      this.addIcon();
    }
  }

  // if theselfie has not yet been liked, we need a btn
  addButton() {
    console.log('ADD BUTTON');
    this.btnLike = Hud.CreateHudButton(GetDefaultButtonCostume('like'), this.game);
    this.btnLike.x = this.contentPanel.width - this.btnLike.width * 0.5;
    this.btnLike.y = this.contentPanel.height - this.btnLike.height * 0.5;
    this.btnLike.onInputDown.add(this.handleSelfieLiked, this);
    this.contentPanel.add(this.btnLike);
  }

  // handle likiig selfie
  handleSelfieLiked() {
    this.game.gameController.player.setSelfieLiked(this.locationid);
    this.btnLike.destroy(true);
    this.btnLike = null;
    this.addIcon();
  }

  // if liked, we show icon
  addIcon() {
    console.log('ADD ICON');
    this.iconLike = this.game.make.image(0, 0, 'buttons_sprite', 'btn_like_pink');
    this.iconLike.x = this.contentPanel.width - this.iconLike.width * 0.5;
    this.iconLike.y = this.contentPanel.height - this.iconLike.height * 0.5;
    this.contentPanel.add(this.iconLike);
  }

  closePanel() {
    this.visible = false;
    this.onScreenClosed.dispatch(this);
  }

  destroy() {
    if (this.btnLike) {
      this.btnLike.destroy();
      this.btnLike = null;
    }
    if (this.iconLike) {
      this.iconLike.destroy();
      this.iconLike = null;
    }

    if (this.loadDisplay) {
      this.loadDisplay.destroy();
    }
    // destroy the image
    if (this.image) {
      this.image.destroy(true, this.imageurl != false);
      this.image = null;
    }

    // remove the load listener ( just in case )
    this.game.load.onFileComplete.remove(this.handleImageLoaded, this);

    // destroy other assets

    this.contentPanel.destroy(true);
    this.contentPanel = null;

    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/overlays/ScreenOverlaySelfie.js